import React from 'react';
import { Label, Row, Col, Button, Input } from 'reactstrap';
import SelectAsyncComponent from '../../../../componentes/select/select-async.component';
import Switch from 'react-switch';
import IntlMessage from '../../../../../src/helpers/intlMessage';

const ConfigMapaMacroscopicoPage = props => (
  <div>
    <div
      style={{
        height: `${props.altura}px`,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden'
      }}
    >
      {props.configs.map((conf, i) => {
        return conf.key === 'Cd_med_padrao_macro' ? (
          <div key={i} className='config-item'>
            <Row>
              <Label className='select-med-padrao-mapa'>
              <IntlMessage id = "dashboards.general.patternDoctor"/></Label>
              <br />
              <div
                style={{
                  flex: 1,
                  height: '38px',
                  marginLeft: '15px',
                  marginRight: '15px',
                  maxWidth: '500px'
                }}
              >
                <SelectAsyncComponent
                  options={conf.options}
                  onChange={event => {
                    props.updateStateMedicoPadraoMacroscopista(event);
                  }}
                  value={conf.value}
                  styles={{
                    width: '300px',
                    marginLeft: '15px',
                    marginTop: '7px'
                  }}
                />
              </div>
            </Row>
          </div>
        ) : conf.key === 'Limitelaminas' ? (
          <div key={i} className='config-item'>
            <Row>
              <Col style={{ minWidth: '85%' }}>
                <Label> {conf.nome} {/* <IntlMessage id = "dashboards.general.enableContinuousGeneration"/> */}</Label>
                <Input
                  value={conf.valor}
                  className='max-num-laminas'
                  type={'number'}
                  onChange={props.numeroMaximoLaminasUpdate}
                />
              </Col>
            </Row>
          </div>
        ) : (
          <div key={i} className='config-item'>
            <Row>
              <Col style={{ minWidth: '85%' }}>
                <Label> {conf.nome} {/* {<IntlMessage id = "dashboards.general.maximumNumberBlades"/>} */}</Label>
              </Col>
              <Col>
                <Switch
                  onChange={e => {
                    props.toggleSwitch(conf.id, e);
                  }}
                  checked={conf.valor}
                />
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
    <Button color='primary' onClick={props.salvar}>
      <IntlMessage id = "dashboards.examDetail.save"/>
    </Button>
  </div>
);

export default ConfigMapaMacroscopicoPage;


// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/mapa_macroscopico/mapa-macroscopico.page.js